import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { askMoo } from '../../../queries/ask-moo';
import { updateUserPreferences } from '../api';
import { getData } from '../../../utils/functional/fp';
import { useAuth } from '../../hooks/useAuth';

export function useUserPreferences() {
  const { isAuthenticated } = useAuth();
  return useQuery({
    ...askMoo.userPreferences(),
    enabled: isAuthenticated,
    staleTime: 5 * 60 * 1000,
  });
}

export function useUpdateUserPreferences() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: { defaultAgentId: string | null }) =>
      updateUserPreferences({ data }).then(getData),
    onSuccess: (response) => {
      queryClient.setQueryData(askMoo.userPreferences().queryKey, response);
    },
  });
}
